import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';

import {openModalFromUrl} from 'utils/modals';

import Page from 'components/Page';
import {Container} from 'containers/types';
import {
  default as LoginRequired,
  LoginRequiredProps
} from 'components/LoginRequired';
import VisibleIf from 'components/VisibleIf';
import BookingNotesModal from 'components/BookingNotesModal';
import {ConfirmationModal} from 'components/CommonModals';
import AgreementUserTakePhotoModal from 'components/AgreementUserTakePhotoModal';

import {
  InfoSection,
  ArrivalsTable,
  DeparturesTable,
  RoomMovesAndStayoversTable,
  RoomInspectionPassModal,
  RoomInspectionRemoveModal,
  FiltersSection
} from './components';

import {requiresPermission, PERMISSIONS} from 'ducks/auth';

import {MODALS} from 'ducks/frontDesk';
import {openModal, isModalOpen, MODALS as BASE_MODALS} from 'ducks/modals';
import {exportXlsx, selectXlsxExporting} from 'ducks/files';

import {exportFrontDesk as exportFrontDeskSdk} from 'sdk/frontDesk';

import {formatDateForApi} from 'utils/datetime';

import './styles.css';

const FRONT_DESK_EXPORT_FILENAME = 'FrontDesk';

class FrontDesk extends React.Component<
  Container &
    LoginRequiredProps &
    ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps
> {
  state = {
    filter: {
      value: 'today',
      dateFrom: '',
      dateTo: ''
    }
  };

  componentDidMount() {
    const {locationRef} = this.props.match.params;

    this.props.requiresPermission(
      {
        permission: PERMISSIONS.VIEW_FRONT_DESK_DASHBOARD,
        locationRef
      },
      () => {
        openModalFromUrl(MODALS, this.props.openModal);
      }
    );
  }

  showToday = () => {
    this.setState({filter: {value: 'today', dateFrom: '', dateTo: ''}});
  };

  showTomorrow = () => {
    this.setState({filter: {value: 'tomorrow', dateFrom: '', dateTo: ''}});
  };

  showDateRange = (dateFrom, dateTo) => {
    this.setState({
      filter: {value: 'period', dateFrom, dateTo}
    });
  };

  exportFrontDesk = () => {
    const {locationRef} = this.props.match.params;
    const {filter} = this.state;

    const exportData = {
      locationRef,
      option: filter.value,
      dateFrom: formatDateForApi(filter.dateFrom),
      dateTo: formatDateForApi(filter.dateTo)
    };

    this.props.exportXlsx({
      exportData,
      exportSdk: exportFrontDeskSdk,
      fileName: FRONT_DESK_EXPORT_FILENAME
    });
  };

  render() {
    const {
      match: {params: {locationRef}},
      modals: {
        isRoomInspectionPassModalOpen,
        isRoomInspectionRemoveModalOpen,
        isBookingNotesModalOpen,
        agreementUserTakePhotoModal,
        isConfirmationModalOpen
      },
      frontDeskExporting
    } = this.props;

    return (
      <Page activeTab="frontDesk" locationRef={locationRef}>
        <div className="FrontDesk">
          <VisibleIf
            permission={PERMISSIONS.VIEW_FRONT_DESK_DASHBOARD}
            locationRef={locationRef}>
            <div className="FrontDesk__section">
              <FiltersSection
                filter={this.state.filter}
                showToday={this.showToday}
                showTomorrow={this.showTomorrow}
                showDateRange={this.showDateRange}
                exportFrontDesk={this.exportFrontDesk}
                frontDeskExporting={frontDeskExporting}
              />
            </div>
            <div className="FrontDesk__section">
              <InfoSection />
            </div>
            <div className="FrontDesk__section">
              <ArrivalsTable
                locationRef={locationRef}
                filter={this.state.filter}
              />
            </div>
            <div className="FrontDesk__section">
              <DeparturesTable
                locationRef={locationRef}
                filter={this.state.filter}
              />
            </div>
            <div className="FrontDesk__section">
              <RoomMovesAndStayoversTable
                locationRef={locationRef}
                filter={this.state.filter}
              />
            </div>
            {isRoomInspectionPassModalOpen && <RoomInspectionPassModal />}

            {isRoomInspectionRemoveModalOpen && <RoomInspectionRemoveModal />}

            {agreementUserTakePhotoModal && <AgreementUserTakePhotoModal />}
            {isBookingNotesModalOpen && <BookingNotesModal />}
            {isConfirmationModalOpen && <ConfirmationModal />}
          </VisibleIf>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = state => ({
  frontDeskExporting: selectXlsxExporting(state, FRONT_DESK_EXPORT_FILENAME),
  modals: {
    isRoomInspectionPassModalOpen: isModalOpen(
      state,
      MODALS.ROOM_INSPECTION_PASS
    ),
    isRoomInspectionRemoveModalOpen: isModalOpen(
      state,
      MODALS.ROOM_INSPECTION_REMOVE
    ),
    agreementUserTakePhotoModal: isModalOpen(
      state,
      BASE_MODALS.AGREEMENT_USER_TAKE_PHOTO
    ),
    isBookingNotesModalOpen: isModalOpen(state, BASE_MODALS.BOOKING_NOTES),
    isConfirmationModalOpen: isModalOpen(state, BASE_MODALS.CONFIRM)
  }
});

const mapDispatchToProps = {
  requiresPermission,
  openModal,
  exportXlsx
};

export default connect(mapStateToProps, mapDispatchToProps)(
  LoginRequired(FrontDesk)
);
